import { render, staticRenderFns } from "./CalendarEventEdit.vue?vue&type=template&id=86c2adf6&scoped=true"
import script from "./CalendarEventEdit.vue?vue&type=script&lang=ts"
export * from "./CalendarEventEdit.vue?vue&type=script&lang=ts"
import style0 from "./CalendarEventEdit.vue?vue&type=style&index=0&id=86c2adf6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c2adf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86c2adf6')) {
      api.createRecord('86c2adf6', component.options)
    } else {
      api.reload('86c2adf6', component.options)
    }
    module.hot.accept("./CalendarEventEdit.vue?vue&type=template&id=86c2adf6&scoped=true", function () {
      api.rerender('86c2adf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarEventEdit.vue"
export default component.exports